import { css, html } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { TeComponent } from '../common/te-component';
import { booleanConverter } from '../common/converters';

import { styleMap } from 'lit/directives/style-map';
import { theme } from '../common/theme';

/**
 * Pagination Page Component
 *
 * @slot - Default slot for rendering page number
 */
@customElement('te-pagination-page')
export class TePaginationPage extends TeComponent {
  static styles = [
    ...TeComponent.styles,
    css`
      .te-pagination-page {
        cursor: pointer;
        width: 40px;
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
        position: relative;
        font-size: 14px;
      }

      .te-pagination-page.active::after {
        content: '';
        height: 2px;
        left: 12px;
        width: 16px;
        position: absolute;
        bottom: 2px;
        background-color: ${theme.colors.primary.v0};
        border-radius: 2px;
      }
    `,
  ];
  /** Pagination page is active */
  @property({ type: Boolean, converter: booleanConverter }) active = false;

  getStyle() {
    return {
      color: this.active ? `${theme.colors.primary.v0}` : `${theme.colors.text}`,
    };
  }

  render() {
    const classes = ['te-pagination-page', this.active ? 'active' : ''].filter(Boolean);

    return html`
      <span class=${classes.join(' ')} style=${styleMap(this.getStyle())}>
        <slot id="page-number"></slot>
      </span>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'te-pagination-page': TePaginationPage;
  }
}
